export default __webpack_public_path__ + "static/media/mw5.085cd503.webp";